import React, { useState } from 'react';
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Logo from "../assets/images/logo-white.svg";
import { updateEmail, updatePassword,onLoggedin } from "../actions";
import { createSession, loginUser, dashboardData, getAllDeviceSerials } from '../RestUtil.js';
import {setLastSession,setUserInfo,setDashboardInfo,setDeviceSerials,setCurrentDeviceSerial} from '../Data/SessionData.js';
import styled from 'styled-components';

const RegisterLink = styled.a`
  background: "#BF4F74";
  color: "white";
  font-size: 1em;
  margin: 1em;
  padding: 0.25em 1em;
  border: 2px solid #BF4F74;
  border-radius: 3px;  cursor: pointer;
  `;

function Login() {

  const [email, setEmail] = useState(null);
  const [password, setPassword] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  function handleRegister() {
    window.location = "registration";
  }

  function handleLogin() {
    setIsLoading(true);
    //
    // Invoke rest to login
    //
    // 1. create session
    //  
    console.log("handleLogin");
    createSession().then(resp => {
      console.log("Response",resp);
      let sessionId = resp.id;
      console.log("Session Id",sessionId);
      setLastSession(resp);
      loginUser(sessionId, email, password).then(resp => {
        console.log("loginSuccess",resp);
        console.log("loginSuccess addlDevices",resp.addlDeviceSerials);
        setUserInfo(resp);
        if (resp.userType === 'admin') {
          getAllDeviceSerials(sessionId).then(resp => {
              var listSerials = resp;
              console.log("received list of serials", listSerials);
              setDeviceSerials(listSerials);
              if (listSerials.length > 0) {
                 setCurrentDeviceSerial(listSerials[0]);
                 dashboardData(sessionId,"Live",listSerials[0]).then(resp => {
                  setIsLoading(false);
                  setDashboardInfo(resp);
                  window.location = "dashboard";
                })
                .catch(err2 => {
                  console.log("dashboard failed",err2);          
                  setIsLoading(false);
                })
              }
              else {
                setCurrentDeviceSerial("No Data");
              }
          })
          .catch(err3 => {
            console.log("getAllDeviceSerials failed",err3);          
            setIsLoading(false);
          })
        }
        else {  // regular user
          setCurrentDeviceSerial(resp.deviceSerial);
          dashboardData(sessionId,"Live",resp.deviceSerial).then(resp => {
            setIsLoading(false);
            setDashboardInfo(resp);
            window.location = "dashboard";
          })
          .catch(err2 => {
            console.log("dashboard failed",err2);          
            setIsLoading(false);
          })
        }
      })
      .catch(err => {
        setUserInfo(null);
        console.log("loginFailed",err);        
        setIsLoading(false);
        alert(err?.response?.data || "Login Failed");
      });      
    });
  }
  
    return (
      <div className="theme-cyan">
        {isLoading && 
        <div className="page-loader-wrapper" style={{ display: 'block' }}>
          <div className="loader">
            <div className="m-t-30"><img src="images/logo.png" width="48" height="48" alt="Lucid" /></div>
            <p>Please wait...</p>
          </div>
        </div>
        }
        <div className="hide-border">
          <div className="vertical-align-wrap">
            <div className="vertical-align-middle auth-main">
              <div className="auth-box">
                <div className="top">
                  <img src="images/logo2.png" alt="Lucid" style={{ height: "40px", margin: "10px" }} />
                </div>
                <div className="card">
                  <div className="header">
                    <p className="lead">Login to your account</p>
                  </div>
                  <div className="body">
                    <div className="form-auth-small" action="index.html">
                      <div className="form-group">
                        <label className="control-label sr-only">Email</label>
                        <input
                          className="form-control"
                          id="signin-email"
                          placeholder="Email"
                          type="email"
                          value={email}
                          onChange={val => {
                            setEmail(val.target.value);
                          }}
                        />
                      </div>
                      <div className="form-group">
                        <label className="control-label sr-only">
                          Password
                        </label>
                        <input
                          className="form-control"
                          id="signin-password"
                          placeholder="Password"
                          type="password"
                          value={password}
                          onChange={val => {
                            setPassword(val.target.value);
                          }}
                        />
                      </div>
                      <div className="form-group clearfix">
                        <label className="fancy-checkbox element-left">
                          <input type="checkbox" />
                          <span>Remember me</span>
                        </label>
                      </div>
                      <a
                        className="btn btn-primary btn-lg btn-block" onClick={handleLogin}                        
                      >Login</a>
                      <div className="bottom">
                        <span className="helper-text m-b-10">
                          <i className="fa fa-lock"></i>{" "}
                          <a href={`${process.env.PUBLIC_URL}/forgotpassword`} 
                          >
                            Forgot password?
                          </a>
                        </span>
                        <span>
                          Don't have an account?{" "}
                          <RegisterLink onClick={handleRegister}>Register</RegisterLink>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
}

export default Login;
  